import LegalPage from "../../components/LegalPage";

export default function DonneesPersonnelles() {
  return (
    <LegalPage title="Données personnelles" kicker="RGPD">
      <h2>Vos droits</h2>
      <p>
        Conformément au Règlement Général sur la Protection des Données
        (RGPD) et à la loi française Informatique et Libertés, vous
        disposez à tout moment des droits suivants :
      </p>
      <ul>
        <li>droit d&apos;accès à vos données ;</li>
        <li>droit de rectification ;</li>
        <li>droit à l&apos;effacement (« droit à l&apos;oubli ») ;</li>
        <li>droit à la limitation du traitement ;</li>
        <li>droit à la portabilité ;</li>
        <li>droit d&apos;opposition.</li>
      </ul>

      <h2>Demande de suppression du compte</h2>
      <p>
        Pour demander la suppression complète de votre compte et de vos
        données associées (codes, sessions de jeu, claims, profil),
        envoyez un email à{" "}
        <a
          href="mailto:contact@otra-gaming.fr?subject=Suppression%20de%20mes%20donn%C3%A9es"
          className="text-cyan-300 hover:text-cyan-200"
          data-testid="data-deletion-email-link"
        >
          contact@otra-gaming.fr
        </a>{" "}
        avec pour objet « Suppression de mes données ». La suppression
        est définitive : aucun retour arrière n&apos;est possible.
      </p>

      <h2>Délais</h2>
      <p>
        Nous traitons votre demande sous 30 jours maximum. Certaines
        données peuvent être conservées au-delà uniquement pour des
        raisons légales (facturation, lutte contre la fraude).
      </p>
    </LegalPage>
  );
}
